import { EmptyState, Table } from '@dixa/lib-shared-habla';

export function EmptyRow(): JSX.Element {
  return (
    <Table.Tr>
      <Table.Td colSpan={3}>
        <EmptyState
          icon={null}
          title="Nothing to show"
          description="You haven't created any forms yet. Click on the purple button to get started!"
        />
      </Table.Td>
    </Table.Tr>
  );
}
